import { useContext } from 'react';

import { FilterBarContext } from '../contexts/FilterBarContext.js';
import type { FilterBarContextProps } from '../types/shared-filter-types.js';

export const useFilterBarContext = (): FilterBarContextProps =>
  useContext(FilterBarContext);
